import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useWindowResizeEvent } from '@wix/da-hooks/pkg/useWindowResizeEvent';
import { DeviationViewContext } from '../../Context';
import StashPageContent from '../_partials/StashPageContent';
import SiteFooter from '../../SiteFooter';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { SubscriptionPurchaseFTUEContextProvider } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import { getBiEventComponentByType } from '../redux/helpers';
import { getDeviationType, getDeviationResourceType } from '../../DeviationViews/_helpers';
import Notifications from '../../Notifications';
import { useDeviationChangedCallback } from '../hooks/useDeviationChangedCallback';
import DeviationPageHeader from '../_partials/DeviationPageHeader';
import DeviationPageLoader from '../_partials/DeviationPageLoader';
import { MatureDeviationContextProvider } from '../../Context/MatureDeviationContext';
import deviationPageStyles from '../DeviationPage.scss';
const StashPage = ({ deviation, onLoad, viewMode, onScreenResize })=>{
    var _deviation_author;
    useWindowResizeEvent(onScreenResize);
    useDeviationChangedCallback(deviation, onLoad);
    useEffect(()=>{
        onScreenResize(window.innerWidth, window.innerHeight);
    }, [
        onScreenResize
    ]);
    const biComponent = getBiEventComponentByType(getDeviationType(deviation));
    var _deviation_author_useridUuid;
    return /*#__PURE__*/ React.createElement(DeviationViewContext.Provider, {
        value: viewMode
    }, /*#__PURE__*/ React.createElement("main", {
        role: "main",
        className: classnames(deviationPageStyles['root'])
    }, /*#__PURE__*/ React.createElement(DeviationPageHeader, null), !deviation && /*#__PURE__*/ React.createElement(DeviationPageLoader, null), deviation && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            view: 'stash',
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            page_typeid: getDeviationResourceType(deviation),
            page_itemid: deviation.deviationId,
            creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : '',
            component: biComponent,
            sectionname: 'stash'
        }
    }, /*#__PURE__*/ React.createElement(MatureDeviationContextProvider, {
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(SubscriptionPurchaseFTUEContextProvider, {
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(StashPageContent, {
        deviation: deviation
    })))), /*#__PURE__*/ React.createElement(SiteFooter, null)), /*#__PURE__*/ React.createElement(Notifications, {
        wrapperClassName: classnames(viewMode === DeviationViewMode.Normal && deviationPageStyles['stage-notifications'])
    }));
};
StashPage.displayName = 'StashPage';
export default StashPage;
